import { render } from "./SocialModal.vue?vue&type=template&id=a901b8ac&scoped=true"
import script from "./SocialModal.vue?vue&type=script&lang=js"
export * from "./SocialModal.vue?vue&type=script&lang=js"

import "./SocialModal.vue?vue&type=style&index=0&id=a901b8ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a901b8ac"]])

export default __exports__